import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { SetColorsService } from 'core'

@Component({
  selector: 'bmprod-page-not-found',
  templateUrl: './bmprod-page-not-found.component.html',
  styleUrls: ['./bmprod-page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodPageNotFoundComponent implements OnInit {
  colorSettingsMode = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
